var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5441",
    "data-name": "Group 5441",
    transform: "translate(0.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5460",
    "data-name": "Group 5460"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1980",
    "data-name": "Rectangle 1980",
    width: 50,
    height: 50,
    rx: 25,
    transform: "translate(-0.074)",
    fill: "#3160d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    transform: "translate(14 14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67643",
    "data-name": "Path 67643",
    d: "M11.25,2.027c3,0,3.36.011,4.546.066a4.963,4.963,0,0,1,3.382,1.229A4.931,4.931,0,0,1,20.407,6.7c.054,1.186.066,1.542.066,4.546s-.011,3.36-.066,4.546a4.987,4.987,0,0,1-1.229,3.382A4.929,4.929,0,0,1,15.8,20.407c-1.186.054-1.542.066-4.546.066s-3.36-.011-4.546-.066a5.023,5.023,0,0,1-3.382-1.229A4.958,4.958,0,0,1,2.092,15.8c-.054-1.186-.066-1.542-.066-4.546s.011-3.36.066-4.546A5,5,0,0,1,3.322,3.322,4.941,4.941,0,0,1,6.7,2.092c1.186-.054,1.542-.066,4.546-.066M11.25,0C8.195,0,7.811.013,6.611.067A6.953,6.953,0,0,0,1.888,1.888,6.941,6.941,0,0,0,.067,6.611C.013,7.811,0,8.195,0,11.25s.013,3.439.067,4.639a6.96,6.96,0,0,0,1.821,4.723,6.947,6.947,0,0,0,4.723,1.821c1.2.054,1.583.068,4.639.068s3.439-.013,4.639-.068a6.957,6.957,0,0,0,4.723-1.821,6.938,6.938,0,0,0,1.821-4.723c.054-1.2.068-1.583.068-4.639s-.013-3.439-.068-4.639a6.956,6.956,0,0,0-1.821-4.723A6.953,6.953,0,0,0,15.889.067C14.689.013,14.305,0,11.25,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67644",
    "data-name": "Path 67644",
    d: "M11.615,5.838a5.777,5.777,0,1,0,5.777,5.777A5.777,5.777,0,0,0,11.615,5.838Zm0,9.527a3.75,3.75,0,1,1,3.75-3.75A3.75,3.75,0,0,1,11.615,15.365Z",
    transform: "translate(-0.365 -0.365)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    cx: 1.35,
    cy: 1.35,
    r: 1.35,
    transform: "translate(15.906 3.894)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b675d32486bce5a0c299c47a20ace5ec.svg";
export { ForwardRef as ReactComponent };